import HttpService from '../services/HttpService';

export const UPDATE_STATUSES = 'update_statuses';

export const getSiteStatuses = (force = false) => {
  return (dispatch, getState) => {
    const state = getState();
    if (!force && state.StatusesReducer.statuses.length > 0) {
      return;
    }

    return gSS().then((data) => {
      const statuses = data.items;
      dispatch({ type: UPDATE_STATUSES, payload: statuses });
    });
  };
};

export const gSS = () => {
  return HttpService.get('/admin/statuses')
    .then((response) => response.json())
    .then((data) => data);
};
